// extracted by mini-css-extract-plugin
export default {"aboutSectionTwo":"SectionTwo_aboutSectionTwo__vV9o+"};